import { css, useTheme } from "@emotion/react";
import { omit } from "lodash/fp";
import { Fragment } from "react";

import {
  Card,
  CardContent,
  CardTitle,
  // CardMeta,
  // Time,
  Button,
  Typography,
  useThemeProps,
  handleComponentsProp,
  parseStyle,
  TearOffDate,
} from "../../../wsui/base";

const DefaultExcerpt = Typography;
const DefaultButton = Button;

export default function EventPostCard(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "EventPostCard" });
  props = useThemeProps({ props, name: "PostCard" });
  let {
    as: Component = Card,
    post,
    components = {},
    // dateFormat = {
    //   year: "numeric",
    //   month: "long",
    //   day: "numeric",
    // },
    style,
    buttonMarginTop = 5,
    titleProps = { variant: "h4" },
    // metaProps = {},
    // visibleFields,
    isFieldVisible,
    ctaVariant,
    align,
    ...restProps
  } = omit(["dateFormat", "metaProps", "visibleFields"], props);
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const contentJustify =
    contentAlign === "right"
      ? "end"
      : contentAlign === "center"
        ? "center"
        : "start";
  const layoutJustify =
    contentAlign === "right"
      ? "flex-end"
      : contentAlign === "center"
        ? "center"
        : "flex-start";
  titleProps = {
    ...titleProps,
    align: titleProps.align ?? contentAlign,
  };

  let { title, image, link, date, description, cta } = post;

  let {
    Button,
    Excerpt,
    Title,
    // Meta,
  } = handleComponentsProp(components, {
    Button: DefaultButton,
    Excerpt: DefaultExcerpt,
    Title: CardTitle,
    // Meta: CardMeta,
  });

  return (
    <Component
      title={isFieldVisible("title") ? title : null}
      link={link}
      image={isFieldVisible("image") ? image : null}
      css={css`
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      {({ hasImage }) => (
        <Fragment>
          {hasImage && isFieldVisible("date") && (
            <TearOffDate
              date={date}
              css={css`
                position: absolute;
                top: 0;
                margin: ${theme.getLength(5)};
              `}
            />
          )}
          <CardContent
            css={css`
              text-align: ${contentAlign || "start"};
            `}
          >
            <div
              css={css`
                display: flex;
                row-gap: inherit;
                align-items: center;
                justify-content: ${layoutJustify};
                column-gap: ${theme.getLength(5)};
              `}
            >
              {!hasImage && isFieldVisible("date") && (
                <TearOffDate
                  date={date}
                  css={css`
                    flex: none;
                    align-self: start;
                  `}
                />
              )}
              <div
                css={css`
                  display: grid;
                  justify-items: ${contentJustify};
                  row-gap: inherit;
                `}
              >
                <Title {...titleProps} />
                {/* {date && (
                  <Meta {...metaProps}>
                    <Time date={date} format={dateFormat} />
                  </Meta>
                )} */}
                {isFieldVisible("description") ? (
                  <Excerpt variant="description" align={contentAlign}>
                    {description}
                  </Excerpt>
                ) : null}
                {cta ? (
                  <Button
                    css={css`
                      justify-self: ${contentJustify};
                      margin-block-start: ${theme.getLength(buttonMarginTop)};
                    `}
                    variant={ctaVariant}
                    {...cta}
                  />
                ) : null}
              </div>
            </div>
          </CardContent>
        </Fragment>
      )}
    </Component>
  );
}
